import React from 'react';
import TeamBadge, { pickTeamLogo } from './TeamBadge';
import { useWidgetLabels } from './WidgetLabelsContext';

/** Home / away names with optional crests. */
export default function MatchRowTeams({ match, size = 24, layout = 'inline' }) {
  const t = useWidgetLabels();

  if (layout === 'versus') {
    return (
      <div className="sw-match-teams-versus min-w-0 flex-1">
        <span className="sw-match-teams-versus__club">
          <TeamBadge name={match.home} logoUrl={pickTeamLogo(match, 'home')} size={size} />
          <span className="sw-match-teams-versus__name">{match.home}</span>
        </span>
        <span className="sw-match-teams-versus__sep">{t('vs')}</span>
        <span className="sw-match-teams-versus__club">
          <TeamBadge name={match.away} logoUrl={pickTeamLogo(match, 'away')} size={size} />
          <span className="sw-match-teams-versus__name">{match.away}</span>
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 min-w-0 flex-1 flex-wrap">
      <TeamBadge name={match.home} logoUrl={pickTeamLogo(match, 'home')} size={size} />
      <p className="font-medium text-sm leading-snug">
        {match.home}{' '}
        <span style={{ color: 'var(--sw-muted)' }}>{t('vs')}</span>{' '}
        {match.away}
      </p>
      <TeamBadge name={match.away} logoUrl={pickTeamLogo(match, 'away')} size={size} />
    </div>
  );
}
